import { Toast } from 'vant'
import { MessageDialog } from '@/plugins/createApi'
import failIcon from '@/assets/tab-pics/warning-icon.png'
import { widthOfDeviceIsMobile } from 'utils'

/**
 * Call different error prompt pop-up boxes on PC and mobile terminals
 * @param {String} message error message
 */
/**
 * PC 端和手机端调用不同错误提示弹框
 * （原来是 `requestMixin.js` 里的 `_createMessageDialog`，一字不改搬出来 —— 多版本菜单 B6 U-B6-2 的几句提示在页面里也要用同一个）
 * @param {String} message 错误信息
 */
export function createMessageDialog(message) {
  const isMobile = widthOfDeviceIsMobile()
  if (isMobile) {
    Toast(message)
  } else {
    MessageDialog.$create({
      $props: {
        title: message,
        icon: failIcon,
        buttonText: 'OK'
      },
    }).show()
  }
}
